/**
 * Formats a number with spaces as a thousand separators and ensures two decimal places.
 *
 * @param number - The number to be formatted.
 * @example
 * formatReadableNumber(1300200.55) -> Returns: "1 300 200.55"
 * formatReadableNumber(8.388) -> Returns: "8.38"
 */
export const formatReadableNumber = (number: number | string): string => {
	const parsedNumber = typeof number === 'string' ? parseFloat(number) : number;

	if (isNaN(parsedNumber)) {
		return '0.00';
	}

	const formattedNumber = parsedNumber.toFixed(2);

	return formattedNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};
